/* eslint-disable */
import { createSlice } from '@reduxjs/toolkit';
// import { isEmpty } from 'lodash';
import { message as toaster } from 'antd';
import { API } from 'api';
import { getPureParams } from '../utils/helpers';
import { getUIVersion } from 'utils/router-static-data';

const initialState = {};

export const pageSlice = createSlice({
	name: 'pageState',
	initialState,
	reducers: {},
});

const generate_report = '/generate-report';
// eslint-disable-next-line consistent-return
function getFilterdAllData(rest) {
	return {
		is_valid: 'All',
		...getPureParams(rest),
	};
}

const regx = /true/;

export const getListAction =
	({
		search_type = '',
		limit = 10,
		offset = 0,
		currentPage,
		filterflag = true,
		version: versionParam,
		...rest
	}) =>
	async () => {
		const isV2UI = getUIVersion() === 'new';
		const version =
			search_type === 'business_unit' ? 'v1' : versionParam ?? (isV2UI ? 'v2' : 'v1');
		const CREDENTIALS = {
			url: '/search',
			data: {
				search_type,
				offset,
				limit,
				fetch_filters: filterflag,
				filter_list: {},
				filter_by: {
					...getPureParams(rest),
				},
			},
			version: version,
		};

		return API.common(CREDENTIALS).then((response) => ({
			rows: response?.data,
			count: response?.meta?.count,
			cities: response?.filter_list?.cities,
			clients: response?.filter_list?.clients,
			projects: response?.filter_list?.projects,
			vehicle_type: response?.filter_list?.vehicle_type,
			vendors: response?.filter_list?.vendors,
			trip_type: response?.filter_list?.trip_type,
		}));
	};
export const getTripListAction =
	({
		search_type = '',
		limit = 10,
		offset = 0,
		currentPage,
		is_valid = 'All',
		fetch_filters = true,
		...rest
	}) =>
	async () => {
		let filters = {};
		console.log(is_valid);
		if (is_valid === 'All') {
			filters = getFilterdAllData(rest);
		}
		if (is_valid === undefined) {
			filters = {
				is_valid: true,
				...getPureParams(rest),
			};
		}
		if (regx.test(is_valid)) {
			filters = {
				is_valid: true,
				...getPureParams(rest),
			};
		}
		if (regx.test(is_valid) === false && is_valid !== 'All' && is_valid !== undefined) {
			filters = {
				is_valid: false,
				...getPureParams(rest),
			};
		}
		console.log(filters);
		const CREDENTIALS = {
			url: '/search',
			data: {
				search_type,
				offset,
				limit,
				filter_by: filters,
				filter_list: {},
				fetch_filters,
			},
		};

		return API.common(CREDENTIALS).then((response) => ({
			rows: response?.data,
			count: response?.meta?.count,
		}));
	};

export const getTripFilterList = (filter) => async () => {
	const CREDENTIALS = {
		url: '/trip/filters',
		data: {
			filter,
		},
	};

	return API.common(CREDENTIALS).then((response) => ({
		rows: response?.data,
	}));
};

/**
 * Build the trips `filter_by` exactly as search posts it. Shared by
 * getTripListActionV2 (search) and exportTripsCSVV2 (export) so the two cannot diverge.
 * Pure move of the block previously inline in getTripListActionV2.
 */
export const buildTripSearchFilterByV2 = ({
	// strip non-filter params so they never leak through ...rest
	search_type,
	limit,
	offset,
	currentPage,
	fetch_filters,
	is_valid = 'All',
	trip_category,
	business_unit_ids = [],
	from_date,
	to_date,
	...rest
} = {}) => {
	let filterBy = {};

	if (is_valid === 'All') {
		filterBy.is_valid = 'All';
	} else if (is_valid === undefined || regx.test(is_valid)) {
		filterBy.is_valid = true;
	} else if (regx.test(is_valid) === false && is_valid !== 'All' && is_valid !== undefined) {
		filterBy.is_valid = false;
	} else {
		filterBy.is_valid = is_valid;
	}

	filterBy = { ...filterBy, ...getPureParams(rest) };

	if (from_date) {
		filterBy.from_date = from_date;
	}
	if (to_date) {
		filterBy.to_date = to_date;
	}

	if (business_unit_ids !== undefined) {
		if (Array.isArray(business_unit_ids)) {
			filterBy.business_unit_ids = business_unit_ids;
		} else if (business_unit_ids) {
			filterBy.business_unit_ids = [business_unit_ids];
		} else {
			filterBy.business_unit_ids = [];
		}
	}

	if (trip_category) {
		filterBy.trip_category = trip_category;
	}

	return filterBy;
};

/**
 * Search Trips V2
 * Endpoint: POST /api/v2/search
 * @param {Object} params
 * @param {String} params.search_type - Should be 'trip'
 * @param {Number} params.limit - Items per page
 * @param {Number} params.offset - Pagination offset
 * @param {String} params.is_valid - 'All', true, false, or undefined
 * @param {Boolean} params.fetch_filters - Whether to fetch filter options
 * @param {String} params.trip_category - Trip category (e.g., 'history')
 * @param {Array} params.business_unit_ids - Array of business unit IDs
 * @param {String} params.from_date - Start date in format 'MM/DD/YYYY HH:mm:ss'
 * @param {String} params.to_date - End date in format 'MM/DD/YYYY HH:mm:ss'
 * @param {Object} params.rest - Additional filter parameters
 * @returns {Promise} API response with trips array and pagination
 */
export const getTripListActionV2 = (params) => async () => {
	const { transformTripListResponseV2ToV1 } = await import('../utils/tripV2Transformations');

	const filterBy = buildTripSearchFilterByV2(params);

	const { search_type = 'trip', limit = 10, offset = 0, fetch_filters = false } = params || {};

	const requestData = {
		search_type,
		offset,
		limit,
		fetch_filters,
		filter_by: filterBy,
		filter_list: {},
	};

	const CREDENTIALS = {
		url: '/search',
		data: requestData,
		version: 'v2',
	};

	return API.common(CREDENTIALS)
		.then((response) => transformTripListResponseV2ToV1(response))
		.catch((error) => {
			console.error('Search trips V2 error:', error);
			return { rows: [], count: 0 };
		});
};

/**
 * Export trips to CSV for Intercity / Intracity pages.
 * Uses the SAME filter builder as search → guaranteed row parity with the page.
 * `params` must be the same object the page passes to getTripListActionV2.
 */
export const exportTripsCSVV2 = (params) => async () => {
	const filter_by = buildTripSearchFilterByV2(params);

	const CREDENTIALS = {
		url: '/report',
		data: {
			report_type: 'trip_csv_export',
			format: 'csv',
			data: { filter_by },
		},
		version: 'v2',
		aclBlockApiCall: false,
	};

	return API.common(CREDENTIALS).then((res) => {
		const downloadUrl = res?.data?.download_url;
		if (downloadUrl) {
			window.open(downloadUrl, '_blank', 'noopener,noreferrer');
			const count = res?.data?.total_records;
			toaster.success(
				typeof count === 'number'
					? `Export ready — ${count} record${count === 1 ? '' : 's'} (download started).`
					: 'Export download started.'
			);
		}
		return { rows: res?.data || {} };
	});
};

/**
 * Which of a client's trips (matching filterBy) are eligible to bulk-close.
 * filterBy: { client_id, trip_status_id, trip_category? }
 */
export const checkTripCloseEligibility = (filterBy) => async () => {
	const CREDENTIALS = {
		url: '/search',
		data: {
			search_type: 'bulk_close_trip_eligibility',
			filter_by: filterBy,
		},
		version: 'v2',
	};

	return API.common(CREDENTIALS)
		.then((response) => response?.data || { eligible: [], not_eligible: [] })
		.catch((error) => {
			console.error('Bulk-close eligibility check error:', error);
			return { eligible: [], not_eligible: [] };
		});
};

/**
 * Close many trips in one call. Returns { closed, failed, total_count,
 * success_count, failed_count } - never rejects on a partial failure, since
 * the backend reports per-trip success/failure rather than all-or-nothing.
 */
export const bulkCloseTrips = (tripIds) => async () => {
	const CREDENTIALS = {
		url: '/update',
		data: {
			update_type: 'bulk_close_trip',
			data: { trip_ids: tripIds },
		},
		version: 'v2',
	};

	return API.common(CREDENTIALS).then((res) => res);
};

export const getTripFilterListWithContext =
	(filter, filter_by = {}) =>
	async () => {
		const CREDENTIALS = {
			url: '/trip/filters',
			data: {
				filter,
				...(Object.keys(filter_by).length > 0 && { filter_by }),
			},
		};

		return API.common(CREDENTIALS).then((response) => ({
			rows: response?.data,
		}));
	};

/**
 * Build trip_info object for v2 API
 * @param {Object} tripData - Trip data from form
 * @param {Object} moment - Moment library instance
 * @returns {Object|null} trip_info object or null if empty
 */
const buildTripInfoV2 = (tripData, moment) => {
	const tripInfo = {};

	if (tripData.reporting_date && tripData.reporting_time) {
		const reportingMoment = moment.isMoment(tripData.reporting_date)
			? tripData.reporting_date
			: moment(tripData.reporting_date);
		tripInfo.reporting_date = reportingMoment.format('YYYY-MM-DD');
		tripInfo.reporting_time = tripData.reporting_time.split(' ')[1];
	}

	if (tripData.end_km !== undefined && tripData.end_km !== null && tripData.end_km !== '') {
		tripInfo.end_km = Number(tripData.end_km);
	}

	if (tripData.special_instructions) {
		tripInfo.special_instructions = tripData.special_instructions;
	}

	if (tripData.load_details) {
		tripInfo.load_details = tripData.load_details;
	}

	return Object.keys(tripInfo).length > 0 ? tripInfo : null;
};

/**
 * Build v2 trip data object
 * @param {Object} tripData - Trip data from form
 * @param {Function} convertMomentToV2Date - Date conversion function
 * @returns {Object} v2 trip data object
 */
const buildV2TripData = (tripData, convertMomentToV2Date) => {
	const v2TripData = {
		trip_type: tripData.trip_type || 'regular',
		project_id: tripData.project_id,
		vendor_id: tripData.vendor_id,
		driver_id: tripData.driver_id ? tripData.driver_id : undefined,
		vehicle_id: tripData.vehicle_id ? tripData.vehicle_id : undefined,
		vehicle_number:
			tripData.vehicle_number && tripData.vehicle_number.trim()
				? tripData.vehicle_number.trim()
				: undefined,
		route_id: tripData.route_id ? tripData.route_id : undefined,
		gps_tracking_id: tripData.gps_tracking_id || undefined,
		temperature_required: tripData.temperature_required || false,
		pod_required: tripData.pod_required !== undefined ? tripData.pod_required : true,
		start_date: tripData?.start_date,
		start_time: tripData?.start_time,
		end_time: tripData.end_time ? convertMomentToV2Date(tripData.end_time) : undefined,
		adhoc_request_id: tripData.adhoc_request_id ? tripData.adhoc_request_id : undefined,
	};

	// Remove undefined values
	Object.keys(v2TripData).forEach((key) => {
		if (v2TripData[key] === undefined) {
			delete v2TripData[key];
		}
	});

	return v2TripData;
};

/**
 * Create Trip V2
 * Endpoint: POST /api/v2/create
 * @param {Object} tripData - Trip data from form
 * @param {Function} setErrors - Error handler function
 * @param {Boolean} isEditMode - Whether this is an edit operation
 * @returns {Promise} API response
 */
export const createTripV2 =
	({ tripData, setErrors, isEditMode = false }) =>
	async () => {
		// Import transformation utilities and moment dynamically
		const { convertMomentToV2Date } = await import('../utils/tripV2Transformations');
		const moment = (await import('moment')).default;

		// Build v2 trip data
		const v2TripData = buildV2TripData(tripData, convertMomentToV2Date);
		// Validate that either vehicle_id or vehicle_number is present
		if (!v2TripData.vehicle_id && !v2TripData.vehicle_number) {
			const errorMessage = 'Either vehicle_id or vehicle_number is required';
			if (setErrors) {
				setErrors({ vehicle: errorMessage });
			}
			throw new Error(errorMessage);
		}

		if (
			tripData.start_km !== undefined &&
			tripData.start_km !== null &&
			tripData.start_km !== ''
		) {
			v2TripData.start_km = Number(tripData.start_km);
		}

		// Build trip_info object
		const tripInfo = buildTripInfoV2(tripData, moment);
		if (tripInfo) {
			v2TripData.trip_info = tripInfo;
		}

		// Build request data
		const requestData = {
			create_type: 'trip',
			data: v2TripData,
		};

		// For edit mode, use update endpoint
		if (isEditMode && tripData.id) {
			requestData.update_type = 'trip';
			requestData.data.id = tripData.id;
		}

		const CREDENTIALS = {
			url: isEditMode ? '/update' : '/create',
			data: requestData,
			setErrors,
			version: 'v2',
		};

		return API.common(CREDENTIALS).then((response) => {
			if (response?.status === 'success') {
				const messageText = isEditMode
					? 'Trip updated successfully'
					: response?.message || 'Trip created successfully';
				toaster.success(messageText);
			}
			return response;
		});
	};

export const addUser =
	({ data, setErrors, isEditMode = false, version = undefined }) =>
	async () => {
		console.log('data', data);
		const isV2UI = getUIVersion() === 'new';
		console.log('setErrors', setErrors);
		let url = '/create';
		if (isEditMode) {
			url = '/update';
		}
		const CREDENTIALS = {
			url,
			data,
			setErrors,
			version: isV2UI ? 'v2' : 'v1',
		};
		// console.log('CREDENTIALS', CREDENTIALS);
		// debugger;
		return API.common(CREDENTIALS).then((res) => res);
	};

export const addBillRegenration =
	({ data, setErrors }) =>
	async () => {
		console.log('data', data);
		console.log('setErrors', setErrors);
		const url = '/update';
		const CREDENTIALS = {
			url,
			data,
			setErrors,
		};

		return API.common(CREDENTIALS).then((res) => res);
	};

export const exportSlice =
	({ data }) =>
	async () => {
		console.log('data', data);
		const url = generate_report;
		const CREDENTIALS = {
			url,
			data,
			aclBlockApiCall: false,
		};

		return API.common(CREDENTIALS).then((res) => {
			window.open(res?.data?.download_url);
		});
	};

export const exportInvoice =
	({ data, openNewWindow = true }) =>
	async () => {
		const url = generate_report;
		const CREDENTIALS = {
			url,
			data,
			aclBlockApiCall: false,
		};

		return API.common(CREDENTIALS).then((res) => {
			if (openNewWindow) {
				window.open(res?.data?.download_url);
			}
			return {
				rows: res?.data,
			};
		});
	};

export const exportDownloadSlice =
	({ data, openNewWindow = true }) =>
	async () => {
		console.log('data', data);
		const url = '/create';
		const CREDENTIALS = {
			url,
			data,
			aclBlockApiCall: false,
		};

		return API.common(CREDENTIALS).then((res) => {
			if (openNewWindow) {
				window.open(res?.data?.download_url);
			}
			return {
				rows: res?.data,
			};
		});
	};

export const getPincodeList = (pin_code) => async () => {
	const CREDENTIALS = {
		url: '/search',
		data: {
			search_type: 'pin_code',
			filter_by: {
				pin_code,
			},
		},
	};

	return API.common(CREDENTIALS).then((response) => {
		if (response?.meta?.count === 0) {
			toaster.error('Not a valid Pincode, please try something else!');
		}
		return {
			rows: response?.data,
			count: response?.meta?.count,
		};
	});
};

export const getTemperatureListAction =
	({ search_type = '', limit = 1000, offset = 0, currentPage, ...rest }) =>
	async () => {
		const CREDENTIALS = {
			url: '/search',
			data: {
				search_type,
				offset,
				limit,
				filter_by: {
					...getPureParams(rest),
				},
			},
		};

		return API.common(CREDENTIALS).then((response) => ({
			rows: response?.data,
			count: response?.meta?.count,
		}));
	};

export const exportFcmToken =
	({ data }) =>
	async () => {
		console.log('data', data);
		const url = '/register-device-token';
		const CREDENTIALS = {
			url,
			data,
			aclBlockApiCall: false,
		};

		return API.common(CREDENTIALS);
	};

export const removeFcmToken =
	({ data }) =>
	async () => {
		console.log('data', data);
		const url = '/logout-device-token';
		const CREDENTIALS = {
			url,
			data,
			aclBlockApiCall: false,
		};

		return API.common(CREDENTIALS);
	};

export const updateProofOfDelivery =
	({ data, setErrors }) =>
	async () => {
		const isV2UI = getUIVersion() === 'new';
		const url = '/update';
		const CREDENTIALS = {
			url,
			data,
			setErrors,
			version: isV2UI ? 'v2' : 'v1',
		};

		return API.common(CREDENTIALS).then((res) => res);
	};

/**
 * End Trip V2
 * Endpoint: POST /api/v2/update
 * @param {Object} tripData - Trip end data
 * @param {Number} tripData.id - Trip ID (required)
 * @param {String} tripData.end_time - End time in ISO format
 * @param {Number} tripData.end_km - End KM reading (for intracity trips)
 * @param {Number} tripData.trip_end_reason - Trip end reason ID (when start_km === end_km)
 * @param {Array} tripData.odometer_end - Array of S3 keys for odometer end images (for intracity)
 * @param {Function} setErrors - Error handler function
 * @returns {Promise} API response
 */
export const endTripV2 =
	({ tripData, setErrors }) =>
	async () => {
		// Import transformation utilities dynamically
		const { convertMomentToV2Date } = await import('../utils/tripV2Transformations');

		const v2TripData = {
			id: tripData.id,
		};

		// Add end_time if provided
		if (tripData.end_time) {
			v2TripData.end_time = convertMomentToV2Date(tripData.end_time);
		}
		if (tripData.end_km !== undefined && tripData.end_km !== null && tripData.end_km !== '') {
			v2TripData.end_km = Number(tripData.end_km);
		}

		// Build trip_info for odometer reading and trip end reason
		const tripInfo = {};

		if (tripData.trip_end_reason) {
			tripInfo.trip_end_reason_id = Number(tripData.trip_end_reason);
		}

		if (Object.keys(tripInfo).length > 0) {
			v2TripData.trip_info = tripInfo;
		}

		// Add trip_documents for odometer_end (intracity trips)
		if (
			tripData.odometer_end &&
			Array.isArray(tripData.odometer_end) &&
			tripData.odometer_end.length > 0
		) {
			v2TripData.trip_documents = {
				odometer_end: tripData.odometer_end,
			};
		}

		const requestData = {
			update_type: 'trip',
			data: v2TripData,
		};

		const CREDENTIALS = {
			url: '/update',
			data: requestData,
			setErrors,
			version: 'v2',
		};

		return API.common(CREDENTIALS).then((response) => {
			if (response?.status === 'success') {
				toaster.success(response?.message || 'Trip closed successfully');
			}
			return response;
		});
	};

/**
 * Create Proof of Delivery V2
 * Endpoint: POST /api/v2/create
 * @param {Object} podData - POD creation data
 * @param {Number} podData.trip_id - Trip ID (required, must exist in trips_v2, trip must be completed)
 * @param {Number} podData.consignment_note_id - Consignment note ID (optional)
 * @param {Function} setErrors - Error handler function
 * @returns {Promise} API response with created POD data
 */
export const createProofOfDeliveryV2 =
	({ podData, setErrors }) =>
	async () => {
		const requestData = {
			create_type: 'proof_of_delivery',
			data: {
				trip_id: podData.trip_id,
				...(podData.consignment_note_id && {
					consignment_note_id: podData.consignment_note_id,
				}),
			},
		};

		const CREDENTIALS = {
			url: '/create',
			data: requestData,
			setErrors,
			version: 'v2',
		};

		return API.common(CREDENTIALS).then((response) => {
			if (response?.status === 'success') {
				toaster.success(response?.message || 'Proof of delivery created successfully');
			}
			return response;
		});
	};

/**
 * Update Proof of Delivery V2
 * Endpoint: POST /api/v2/update
 * @param {Object} podData - POD update data
 * @param {Number} podData.id - POD ID (required, must exist in proof_of_deliveries_v2)
 * @param {Number} podData.trip_id - Trip ID (optional, for context)
 * @param {String} podData.key - S3 key for POD document (proof_of_delivery_upload/)
 * @param {String} podData.status - POD status: "pending" | "uploaded" | "verified" | "rejected"
 * @param {String} podData.rejection_reason - Required if status = "rejected"
 * @param {Object} podData.additional_charges - Additional charges object (intercity only)
 *   - clientHaltCharges, clientMiscellaneousCharges, clientTollCharges,
 *   - clientUnloadingCharges, clientExtraKmCharges, clientLabourCharges,
 *   - clientExtraHrCharges, clientDeductionAmount
 * @param {String} podData.additional_charges_proof_key - Required if any additional_charges > 0 (intercity only)
 * @param {Function} setErrors - Error handler function
 * @returns {Promise} API response
 *
 * Business Rules:
 * - If status = "rejected", rejection_reason is MANDATORY
 * - If status = "rejected", trip status reverts to "In Progress" (trip_status_id = 2)
 * - If any additional_charges > 0 (intercity only), additional_charges_proof_key is MANDATORY
 */
export const updateProofOfDeliveryV2 =
	({ podData, setErrors }) =>
	async () => {
		const isV2UI = getUIVersion() === 'new';
		const requestData = {
			update_type: 'proof_of_delivery',
			data: {
				id: podData.id,
				...(podData.trip_id && { trip_id: podData.trip_id }),
				...(podData.key && { key: podData.key }),
				...(podData.status && { status: podData.status }),
				...(podData.rejection_reason !== undefined && {
					rejection_reason: podData.rejection_reason,
				}),
				...(podData.additional_charges && {
					additional_charges: podData.additional_charges,
				}),
				...(podData.additional_charges_proof_key && {
					additional_charges_proof_key: podData.additional_charges_proof_key,
				}),
			},
		};

		const CREDENTIALS = {
			url: '/update',
			data: requestData,
			setErrors,
			version: isV2UI ? 'v2' : 'v1',
		};

		return API.common(CREDENTIALS).then((response) => {
			if (response?.status === 'success') {
				const message =
					response?.message ||
					(response?.data?.trip_reopened
						? 'POD rejected and trip reopened to In Progress'
						: 'Proof of delivery updated successfully');
				toaster.success(message);
			}
			return response;
		});
	};

/**
 * Upload Proof of Delivery V2
 * Endpoint: POST /api/v2/update
 * @param {Object} podData - POD upload data
 * @param {String} podData.data_key - S3 key for POD file (required)
 * @param {Number} podData.trip_id - Trip ID (required)
 * @param {Number} podData.consignment_note_id - LR/Consignment note ID (optional, for intercity)
 * @param {Object} podData.charges - Additional charges object
 * @param {String} podData.additional_charges_proof_key - S3 key for additional charges proof
 * @param {Boolean} podData.pod_force_upload - Force upload flag
 * @param {Function} setErrors - Error handler function
 * @returns {Promise} API response
 */
export const uploadProofOfDeliveryV2 =
	({ podData, setErrors, podUpload = true }) =>
	async () => {
		const isV2UI = getUIVersion() === 'new';
		const normalizedKey = Array.isArray(podData.data_key)
			? podData.data_key.filter(Boolean)
			: podData.data_key
			? [podData.data_key]
			: [];
		const requestData = {
			update_type: podUpload ? 'upload_proof_of_delivery' : 'proof_of_delivery',
			data: {
				trip_id: podData.trip_id,
				...((podData.id || podData.pod_id) && { id: podData.id || podData.pod_id }),
				key: normalizedKey,
				...(podData.consignment_note_id && {
					consignment_note_id: podData.consignment_note_id,
				}),
				...(podData.charges && { additional_charges: podData.charges }),
				...(podData.additional_charges_proof_key && {
					additional_charges_proof_key: podData.additional_charges_proof_key,
				}),
				...(podData.pod_force_upload === true && { pod_force_upload: true }),
			},
		};

		const CREDENTIALS = {
			url: '/update',
			data: requestData,
			setErrors,
			...(isV2UI && { version: 'v2' }),
			aclBlockApiCall: false,
		};

		return API.common(CREDENTIALS).then((response) => ({
			data: response?.data,
			error: response?.error,
		}));
	};

export const getTemperatureData =
	({
		search_type = 'temperature_history',
		trip_id,
		breach_only,
		limit = 10,
		offset = 0,
		sort_column,
		sort_direction,
	}) =>
	async () => {
		const CREDENTIALS = {
			url: '/search',
			data: {
				search_type,
				filter_by: {
					trip_id,
					breach_only,
				},
				limit,
				offset,
				sort_column,
				sort_direction,
			},
		};

		return API.common(CREDENTIALS).then((response) => ({
			rows: response?.data,
			count: response?.meta?.count,
		}));
	};

export const getLoadingHistory =
	({ trip_id }) =>
	async () => {
		const CREDENTIALS = {
			url: '/search',
			data: {
				search_type: 'temperature_history_summary',
				filter_by: {
					trip_id,
				},
			},
		};

		return API.common(CREDENTIALS).then((response) => response);
	};
export const generateBreachesReport =
	({ trip_id, file_type, breach_only }) =>
	async () => {
		const CREDENTIALS = {
			url: generate_report,
			data: {
				report_type: 'temperature_history_export',
				file_type,
				data: {
					breach_only,
					trip_id,
				},
			},
			aclBlockApiCall: false,
		};

		return API.common(CREDENTIALS).then((res) => {
			window.open(res?.data?.download_url);
		});
	};

export default pageSlice.reducer;
